import { render } from "./CTextArea.vue?vue&type=template&id=4b8c2c1a"
import script from "./CTextArea.vue?vue&type=script&lang=js"
export * from "./CTextArea.vue?vue&type=script&lang=js"

import exportComponent from "/home/ydf/remit/shared/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__